<script>
import ValidationMixin from "@/mixins/validation.mixin.ts";
import { mapActions } from "pinia";
import { useSnackbarStore } from "@/store/snackbar.store.ts";
import CreateCheckCallDialog from "@/views/trips/components/dialogs/CreateCheckCallDialog.vue";
import { useError } from "@/composables/useError.ts";
import PermissionTooltip from "@/components/tooltips/PermissionTooltip.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto.ts";

const { showAPIError } = useError();

export default {
  name: "DispatchConfirmationAction",
  components: { PermissionTooltip, CreateCheckCallDialog },
  mixins: [ValidationMixin],
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
  },
  emits: ["dispatched"],
  data() {
    return {
      showDialog: false,
      preview: false,
      loading: false,
      checkCallPreview: null,
    };
  },
  computed: {
    DispatcherPermissionValue() {
      return DispatcherPermissionValue;
    },
    dialogTitle() {
      return this.preview ? "Dispatch preview" : "Dispatch confirmation";
    },
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    showDispatchConfirmation() {
      this.showDialog = true;
    },
    async confirmDispatched(data) {
      this.loading = true;

      try {
        const response = await this.$api.trips.confirmRouteDispatch(this.trip.id, this.route.id, data);

        if (!response.success || !response.data) {
          showAPIError(response, "Error dispatching route");

          return;
        }

        if (!data.commit) {
          this.checkCallPreview = response.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <permission-tooltip :permission="DispatcherPermissionValue.TripsRouteActions">
    <template #activator="{ disabled }">
      <v-btn
        v-if="!route?.dispatchConfirmed"
        :disabled="disabled"
        block
        class="text-uppercase font-weight-600"
        color="primary"
        v-bind="$attrs"
        variant="flat"
        @click="showDispatchConfirmation"
      >
        Confirm dispatch
      </v-btn>
    </template>

    {{ $t("permission.process-trip") }}
  </permission-tooltip>

  <create-check-call-dialog
    v-model="showDialog"
    v-model:preview="preview"
    :check-call-preview="checkCallPreview"
    :creation-loading="loading"
    :route-id="route.id"
    :route-stops="route.routeStops"
    :title="dialogTitle"
    @create="confirmDispatched"
  >
    <template #subtitle>
      <div class="d-flex align-center mb-4">
        <span class="text-grey-darken-1"> You are about to confirm dispatch for</span>

        <router-link
          v-if="route.truck"
          :to="{ name: 'truck-view', params: { id: route.truck?.id } }"
          class="text-primary text-decoration-none ml-1"
          data-qa="modal-truck-number"
          target="_blank"
        >
          Truck #{{ route.truck?.number }}
        </router-link>
      </div>
    </template>
  </create-check-call-dialog>
</template>

<style lang="scss" scoped></style>
